
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat" 
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/c532a068209b9237070a9d180ab5b484.jpeg')`
      }}>
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-0">
        <div className="text-center text-white">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 px-2">
            信頼できる税務のパートナー
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 max-w-3xl mx-auto px-4 leading-relaxed">
            経験豊富な税理士が、お客様の事業成長をサポートします。<br className="hidden sm:block" />
            税務申告から経営コンサルティングまで、幅広いサービスを提供いたします。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700 w-full sm:w-auto">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-phone-line"></i>
              </div>
              無料相談予約
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900 w-full sm:w-auto">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-download-line"></i>
              </div>
              資料ダウンロード
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
